module.exports = __webpack_public_path__ + "img/receivebox_mint1.aaa2de06.png";